// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ad81e450","455":"6a67602b","977":"e8c20ed2"}[chunkId] + ".chunk.js";
};